/**
 * EndScreen - what happened, for the adult in the room.
 *
 * Deliberately about the SESSION and not about the chart. The chart is 208
 * boxes across ten phases and belongs on the dashboard, where it can be read
 * properly; a game that renders its own version of it will drift from the one
 * the therapist actually uses.
 */

export default function EndScreen({ stats, child, queue, onReplay, onExit }) {
  const minutes = stats.startedAt ? Math.max(1, Math.round((Date.now() - stats.startedAt) / 60000)) : 0;

  return (
    <div className="bp-end">
      <div className="bp-end__card">
        <div className="bp-end__icon" aria-hidden="true">🫧</div>
        <h2>Well played{child ? `, ${child.name}` : ''}</h2>

        <dl className="bp-end__stats">
          <div><dt>Bubbles popped</dt><dd>{stats.popped}</dd></div>
          <div><dt>Turns taken</dt><dd>{stats.trials}</dd></div>
          <div><dt>Turns with a voice heard</dt><dd>{stats.vocalised}</dd></div>
          <div><dt>Levels finished</dt><dd>{stats.levels}</dd></div>
          <div><dt>Minutes</dt><dd>{minutes}</dd></div>
        </dl>

        {queue.practice ? (
          <p className="bp-end__note">
            Practice mode — nothing was recorded. Add a child profile on the
            dashboard to keep progress.
          </p>
        ) : (
          <p className="bp-end__note">
            {queue.sent} turn{queue.sent === 1 ? '' : 's'} saved to the chart
            {queue.pending > 0 && `, ${queue.pending} still waiting to send`}
            {queue.rejected > 0 && `, ${queue.rejected} refused by the engine`}.
          </p>
        )}

        <div className="bp-end__actions">
          <button type="button" className="bp__btn bp__btn--primary" onClick={onReplay}>Play again</button>
          <button type="button" className="bp__btn bp__btn--quiet" onClick={onExit}>Back to games</button>
        </div>
      </div>
    </div>
  );
}
